module.exports = __webpack_public_path__ + "assets/img/floor-slope.47816143.png";